import { Building2 } from 'lucide-react';
import type { CompanyInfo } from '@/modules/Career/Data/careerData';

interface CareerCompaniesProps {
  companies: CompanyInfo[];
}

export default function CareerCompanies({ companies }: CareerCompaniesProps) {
  return (
    <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
      {companies.map((company) => (
        <div key={company.name} className="flex items-center gap-2 text-muted-foreground">
          <Building2 className="h-4 w-4" />
          <span className="text-sm font-medium">{company.name}</span>
        </div>
      ))}
    </div>
  );
}
